import {BaseConfig} from "../../infrastructure/config/base-config";
import {CompetitionsSliderWidgetTerms} from "./competitions-slider-widget.terms";
import {APP} from "../../core/app/consts";

export class CompetitionsSliderWidgetConfig extends BaseConfig {
  source: APP.ANALYTICS.SOURCES;

  static injectables = [CompetitionsSliderWidgetTerms];

  constructor(terms: CompetitionsSliderWidgetTerms) {
    super('competitionsSliderWidget', null, terms);

    this.source = APP.ANALYTICS.SOURCES.slider;
  }
}
